// Утилиты для сортировки кандидатов

export interface SortField {
  field: string;
  direction: 'asc' | 'desc';
}

export function sortCandidates(
  candidates: any[],
  sortFields: SortField[]
): any[] {
  if (!sortFields || sortFields.length === 0) return candidates;

  return [...candidates].sort((a, b) => {
    for (const sortField of sortFields) {
      const { field, direction } = sortField;
      
      let aValue = a[field];
      let bValue = b[field];

      // Обработка специальных полей
      if (field === 'name') {
        aValue = a.name || '';
        bValue = b.name || '';
      } else if (field === 'rating') {
        aValue = a.rating || 0;
        bValue = b.rating || 0;
      } else if (field === 'completed') {
        aValue = a.completed || '';
        bValue = b.completed || '';
      }

      // Сравнение значений
      if (aValue < bValue) {
        return direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction === 'asc' ? 1 : -1;
      }
    }
    return 0;
  });
}
